import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BookingPageHeader = ({ title, subtitle, step, totalSteps, showBackButton = true }) => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-gradient-to-r from-[#1B375B] to-[#659A9B] text-white py-4 md:py-6 px-4 shadow-lg">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 md:gap-4">
            {showBackButton && (
              <button
                onClick={() => navigate(-1)}
                className="p-2 hover:bg-white/10 rounded-full transition-colors flex-shrink-0"
              >
                <ArrowLeft className="w-5 h-5 md:w-6 md:h-6" />
              </button>
            )}
            <div>
              <h1 className="text-lg md:text-2xl font-bold">{title}</h1>
              {subtitle && (
                <p className="text-xs md:text-sm text-white/80 mt-0.5">{subtitle}</p>
              )}
            </div>
          </div>
          
          {step && totalSteps && (
            <div className="flex items-center gap-2 bg-white/20 px-3 md:px-4 py-1.5 md:py-2 rounded-full">
              <span className="text-xs md:text-sm font-bold">
                Step {step} of {totalSteps}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BookingPageHeader;
